import React, { useEffect, useState } from 'react';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import generateMetaData from 'lib/utils/generateMetaData';
import Head from 'next/head';
import axios, { API } from 'lib/config/axios';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import { useDispatch } from 'react-redux';
import { setLoading } from 'redux/features/ui-slice';
import { BLOGS_SORT } from 'lib/utils/CONSTANTS';
import PATHS from 'lib/navigation/paths';
import StyledBox from 'views/rebranded-module/blogs-module/BlogsViewV2/BlogsViewV2.styles';
import { Container, Box } from '@mui/material';
import {
  HeaderSection,
  SearchAndSortSection,
  BlogsListSection,
} from 'views/rebranded-module/blogs-module/BlogsViewV2/components';
import useLayoutHeights from 'views/rebranded-module/common/hooks/UseLayoutHeight';
import { NoAvailableData } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';


const BlogsViewV2 = (props) => {
  const { serverData } = props;
  // init
  const handleErrorResponse = useErrorsHandler();
  const dispatch = useDispatch();
  const appNavigator = useAppNavigator();
  const { LAYOUT_HEIGHT, LAYOUT_HEIGHT_SM } = useLayoutHeights();
  const cmsData = useContent('BlogsPage');
  const getSizedImage = useAdabtiveMultiSizeImage();

  // query
  const { sort_direction: sortDirectionQuery, q } = appNavigator.query;

  // states
  const [blogsData, setBlogsData] = useState(serverData);
  const [sortDirection, setSortDirection] = useState();
  // will used at search input field  like old code
  const [searchQuery, setSearchQuery] = useState('');

  // handlers
  const getBlogsData = (params = {}) => {
    dispatch(setLoading(true));
    axios
      .get(API.blogsList, {
        params: {
          sort_direction: params.sortDirection,
          q: params.query,
        },
      })
      .then((res) => {
        const tempBlogData = {
          ...res.data,
          blog_posts: res.data.blog_posts.map((post) => ({
            ...post,
            path: PATHS.motorcycleTouring.slug(post.slug),
          })),
        };
        setBlogsData(tempBlogData);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      })
      .finally(() => dispatch(setLoading(false)));
  };

  const handleSearchEntryEnter = (searchQuery = '') => {
    if (!searchQuery) {
      appNavigator.push(
        PATHS.motorcycleTouring.index({ sort_direction: sortDirection }),
      );
    } else {
      appNavigator.push(
        PATHS.motorcycleTouring.index({
          q: searchQuery,
          sort_direction: sortDirection,
        }),
      );
    }
  };

  const handleSortDirectionChange = (dir = BLOGS_SORT.descending) => {
    if (q) {
      appNavigator.push(
        PATHS.motorcycleTouring.index({ sort_direction: dir, q }),
      );
    } else {
      appNavigator.push(PATHS.motorcycleTouring.index({ sort_direction: dir }));
    }
  };

  const handleBackBtnClick = () =>
    appNavigator.push(PATHS.motorcycleTouring.index());

  // useEffects
  useEffect(() => {
    if (!serverData) {
      setSortDirection(sortDirectionQuery || BLOGS_SORT.descending);
      getBlogsData({ query: q, sortDirection: sortDirectionQuery });
    }
  }, [appNavigator.query]);
  useEffect(() => {
    // to detect the changes in query (back and forward)
    // undefind not clearing the textField .. it should be empty string
    setSearchQuery(q || '');
  }, [q]);

  return (
    <>
      {blogsData?.seo_values && (
        <Head>{generateMetaData(blogsData.seo_values)}</Head>
      )}

      {blogsData && (
        <StyledBox
          layoutHeightLG={LAYOUT_HEIGHT}
          layoutHeightSM={LAYOUT_HEIGHT_SM}>
          <Container maxWidth="xl" className='BVContainer'>
            <HeaderSection isSearchResultVariant={q} />
            <SearchAndSortSection
              searchQuery={searchQuery}
              handleSearchEntryEnter={handleSearchEntryEnter}
              setSearchQuery={setSearchQuery}
              sortDirection={sortDirection}
              blogsFilteredListCount={blogsData?.filtered_blog_posts_counter}
              handleSortDirectionChange={handleSortDirectionChange}
              query={q}
            />
            {blogsData?.blog_posts.length > 0 ? (
              <BlogsListSection blogs={blogsData.blog_posts} />
            ) : (
              <Box py={16}>
                <NoAvailableData
                  icon= {getSizedImage(cmsData.noResultsIcon)}
                  title={cmsData.noResultsTitle}
                  description={cmsData.noResultsSubtitle}
                  buttonText={cmsData.backToBlogBtnText}
                  handleClick={handleBackBtnClick}
                />
              </Box>
            )}
          </Container>
        </StyledBox>
      )}
    </>
  );
};

export { BlogsViewV2 };
